import {Button, MenuItem} from '@material-ui/core';
import * as AgentNewsAdministrationRouteConstants from 'AgentNewsAdministration/AgentNewsAdministrationRouteConstants';
import 'AgentNewsAdministration/components/AgentNewsAdministration.sass';
import AgentNewsAdministrationMenu from 'AgentNewsAdministration/components/AgentNewsAdministrationMenu';
import {changeNewsFilter, clearNews, deleteNewsEntry, getNews} from 'AgentNewsAdministration/ducks/news';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {ReducerState} from 'rootReducer';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import Column from 'Shared/components/PagedView/Column';
import {withDateFilterProperties, withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import PagedView from 'Shared/components/PagedView/PagedView';
import {toFormattedDate} from 'Shared/utilities/DateFormatter';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';

const AgentNewsAdministration = () => {
  const {news, filter} = useSelector((state: ReducerState) => state.agentNewsAdministration.news);
  const dispatch = useDispatch();
  const changeFilter = withValueChangedHook(filter, changeNewsFilter, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: filter,
  };

  useEffect(
    () => () => {
      dispatch(clearNews());
    },
    []
  );

  useEffect(() => {
    dispatch(getNews(undefined, filter));
  }, [filter]);

  return (
    <PagedView
      pagedViewKey="agentNewsAdministration"
      loadMore={page => {
        getNews(page, filter);
      }}
      actions={<AgentNewsAdministrationMenu />}
      data={news}
    >
      {columnProps => (
        <>
          <Column
            {...columnProps}
            title="Title"
            filterProperties={withStringFilterProperties(filterProperties, 'title')}
            default
          >
            {newsEntry => newsEntry.title}
          </Column>
          <Column
            {...columnProps}
            title="Description"
            filterProperties={withStringFilterProperties(filterProperties, 'description')}
            default
          >
            {newsEntry => newsEntry.description}
          </Column>
          <Column
            {...columnProps}
            title="Publish Date"
            filterProperties={withDateFilterProperties(filterProperties, 'publishDate')}
            default
          >
            {newsEntry => toFormattedDate(newsEntry.publishDate)}
          </Column>
          <Column {...columnProps} title="" isActions default>
            {newsEntry => (
              <>
                <Link to={AgentNewsAdministrationRouteConstants.NewsAdministrationEntry(newsEntry.id!)}>
                  <Button className="primary-action-button" color="primary">
                    Edit
                  </Button>
                </Link>
                <ActionsMenu>
                  <MenuItem onClick={() => dispatch(deleteNewsEntry(newsEntry.id!))}>Delete</MenuItem>
                </ActionsMenu>
              </>
            )}
          </Column>
        </>
      )}
    </PagedView>
  );
};

export default AgentNewsAdministration;
